import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {catchError, map, Observable, of, shareReplay} from 'rxjs';
import {environment} from 'src/environments/environment';

export enum Features {
  AutoRenewalDisclaimer = 'purchase:auto-renewal-disclaimer',
  PurchaseSMSToken = 'purchase:purchase-sms-token',
  MembershipAgreementTemplate = 'membershipAgreementTemplate',
  DynamicFooter = 'dynamicFooter2026'
}

const SYSTEM_FEATURE_FLAG_MODE_ID = 99;

type FeatureFlagObservable = Observable<Record<string, boolean>>;

@Injectable()

export class FeatureFlagService {
  private _httpClient: HttpClient = inject(HttpClient);
  private _cachedData$: FeatureFlagObservable[] = [];

  public getFeatureFlags(uiModeId: number): Observable<Record<string, boolean>> {
    const apiUrl = `${environment.apiUrl}${environment.treatmentApi}featureFlag/${uiModeId}` ;

    if (!this._cachedData$[uiModeId]) {
      this._cachedData$[uiModeId] = this._httpClient.get<Record<string, boolean>>(apiUrl).pipe(
        map((response: any) => response),
        catchError(() => of({} as Record<string, boolean>)),
        shareReplay(1)
      );
    }

    return this._cachedData$[uiModeId];
  }

  public isFeatureEnabled(feature: string): Observable<boolean> {
    return this.getFeatureFlags(SYSTEM_FEATURE_FLAG_MODE_ID).pipe(
      map(flags => !!(flags && flags[feature]))
    );
  }
}
